import React from 'react'
import ImageRaw from '../../../../components/image-raw'
import HiglightSwiper from '../highlight-swiper/highlight-swiper'
import LinearText from '../linear-text/linear-text'

interface HighlightMomentsSectionProps {
    highlightMoments: string[]
}

const HighlightMomentsSection: React.FC<HighlightMomentsSectionProps> = ({highlightMoments}) => {
  return (
    <section className="relative w-full max-w-[2000px] mx-auto overflow-x-hidden pt-[18px] md:!pt-20 xl:pb-[133px] md:pb-[80px] pb-[25px]">
      {/* Main content container - Full screen height */}
      <div className="relative z-30 h-full flex flex-col items-center justify-center gap-[36px]">

        {/* Lineup title - Responsive spacing */}
        <div className='w-fit mx-auto text-center px-[15px]'>
          <LinearText className='uppercase text-[36px] md:text-[48px] font-kpz_font py-5 font-bold'>
            Khoảnh khắc ấn tượng
          </LinearText>
        </div>
{/* w-[296px] h-[158px] */}
        <div className="w-full mx-auto">
          <HiglightSwiper
            highlightMoments={highlightMoments}
            renderHighlightMoment={(highlightMoment) => <ImageRaw className='xl:w-[788px] xl:h-[420px] md:w-[362px] md:h-[192px] w-[296px] h-[158px] rounded-sm' src={highlightMoment} alt='Khoảnh khắc ấn tượng Festival Kidsplaza' />}
            autoPlay={true}
            autoPlayInterval={3000}
            loop={true}
          />
        </div>
      </div>
    </section>
  )
}

export default HighlightMomentsSection